document.addEventListener('DOMContentLoaded', function () {
  const cartForm = document.querySelector('form[action^="/cart"]');
  const poInput = document.getElementById('po-number');
  const poFileInput = document.getElementById('po_file');
  const uploadBtn = document.getElementById('upload-po-btn');

  // 1. Validación antes de ir al Checkout
  if (cartForm && poInput) {
    cartForm.addEventListener('submit', function (e) {
      if (!poInput.value.trim()) {
        e.preventDefault();
        poInput.style.border = '2px solid red';
        alert('Por favor ingresa el número de orden de compra (PO Number).');
      } else {
        poInput.style.border = '';
      }
    });
  }

  // 2. Manejo de la subida del archivo PDF a tu backend
  if (uploadBtn && poFileInput) {
    uploadBtn.addEventListener('click', async function () {
      const file = poFileInput.files[0];
      if (!file) {
        alert('Selecciona un archivo PDF primero.');
        return;
      }

      const formData = new FormData();
      formData.append('po_file', file);

      try {
        const response = await fetch('https://otc.overnighttablecovers.com/storage-file-shopify', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error en el servidor:", errorText);
          alert("Error al subir archivo.");
          return;
        }

        const data = await response.json();

        if (data.url) {
          // Guardar la URL del archivo como atributo del carrito en Shopify
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                "Purchase Order URL": "https://otc.overnighttablecovers.com" + data.url
              }
            })
          });

          alert("Archivo subido y vinculado al carrito correctamente.");
        } else {
          alert("Error al procesar la URL del archivo.");
        }
      } catch (error) {
        console.error(error);
        alert("Error de conexión al subir el archivo.");
      }
    });
  }
});